import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import classNames from "classnames";

import "../styles/components/BlogPostNavigation.scss";

const BlogPostNavigationLink = ({
    slug,
    title,
    previous = false,
    next = false,
    blogPrefix,
}) => {
    if (!slug || !title) {
        return null;
    }

    return (
        <Link
            to={`${blogPrefix}/${slug}`}
            className={classNames("blog-post-navigation-link", {
                previous,
                next,
            })}
        >
            <span className="blog-post-navigation-arrow">
                {previous ? "<" : ">"}
            </span>
            <span className="blog-post-navigation-entry">
                <span className="blog-post-navigation-legend">
                    {previous ? "Previous" : "Next"} post
                </span>
                <span className="blog-post-navigation-title">{title}</span>
            </span>
        </Link>
    );
};

const BlogPostNavigation = ({ previous, next, blogPrefix }) => (
    <div className="blog-post-navigation">
        <div className="blog-post-navigation-section">
            <BlogPostNavigationLink
                previous
                {...previous}
                blogPrefix={blogPrefix}
            />
        </div>
        <div className="blog-post-navigation-section">
            <BlogPostNavigationLink next {...next} blogPrefix={blogPrefix} />
        </div>
    </div>
);

BlogPostNavigation.propTypes = {
    previous: PropTypes.shape({
        slug: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
    }),
    next: PropTypes.shape({
        slug: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
    }),
    blogPrefix: PropTypes.string.isRequired,
};

export default BlogPostNavigation;
